import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

import { getCoreConfig } from '../config/config';

let _cioAnalytics: AnalyticsBrowser | null = null;

export function getCioAnalytics(): AnalyticsBrowser {
  if (!_cioAnalytics) {
    _cioAnalytics = AnalyticsBrowser.load(
      { writeKey: getCoreConfig().customerIoApiKey, cdnURL: 'https://cdp.customer.io' },
      { globalAnalyticsKey: 'cioanalytics' },
    );
  }
  return _cioAnalytics;
}

export const cioAnalytics = {
  track: (...args: Parameters<AnalyticsBrowser['track']>) => getCioAnalytics().track(...args),
  page: (...args: Parameters<AnalyticsBrowser['page']>) => getCioAnalytics().page(...args),
  reset: () => getCioAnalytics().reset(),
  identify: (...args: Parameters<AnalyticsBrowser['identify']>) => getCioAnalytics().identify(...args),
};
